import MultiDomainLogin from '@html/_common/multiDomainLogin';

function OAuthMultidomainHandler() {
  /**
   * Check if URL contains oauth_new_user parameter
   * @returns {boolean}
   */
  this.hasOAuthNewUser = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('oauth_new_user');
  };

  /**
   * Get multidomain login endpoints from API
   * @returns {Promise<Array>}
   */
  this.getLoginEndpoints = async () => {
    try {
      const response = await fetch('/api/central/auth/multidomain-login-endpoints', {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (!result.success) {
        throw new Error('API returned unsuccessful response');
      }

      return result.login_endpoints || [];
    } catch (error) {
      console.error('Failed to get login endpoints:', error);
      return [];
    }
  };

  /**
   * Main handler for OAuth new user multidomain login
   */
  this.handleOAuthNewUser = async () => {
    if (!this.hasOAuthNewUser()) {
      return;
    }

    try {
      const loginEndpoints = await this.getLoginEndpoints();

      if (loginEndpoints.length === 0) {
        return;
      }

      const multiDomainLogin = new MultiDomainLogin();
      await multiDomainLogin.login(loginEndpoints);
    } catch (error) {
      console.error('Error during OAuth multidomain login:', error);
    }
  };

  /**
   * Initialize the handler on page load
   */
  this.init = () => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.handleOAuthNewUser();
      });
    } else {
      this.handleOAuthNewUser();
    }
  };
}

export default OAuthMultidomainHandler;
